module.exports = __webpack_public_path__ + "assets/img/3.d8d0bcb6.png";